import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'lt_LT',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '11ba6c5a-0b36-42c4-bf66-aaa32aa41aa0',
  ''
);
